import SessionService from './SessionService';
import { withIdentityHeaders } from './identityHeaders';

const baseUrl = process.env.REACT_APP_STUDSTOCK_ENDPOINT;

const executeRecaptcha = async (action) => {
    console.log('executeRecaptcha');
    return new Promise((resolve, reject) => {
        try {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: action })
                    .then(token => resolve(token))
                    .catch(error => {
                        console.error('reCAPTCHA execution error:', error);
                        reject(error);
                    });
            });
        } catch (error) {
            console.error('reCAPTCHA ready error:', error);
            reject(error);
        }
    });
};

const getOptionsWithRecaptcha = async (data, action, method = 'POST') => {
    const token = await executeRecaptcha(action);
    console.log('getOptionsWithRecaptcha', token, data, method);
    
    const headers = withIdentityHeaders({
        'Content-Type': 'application/json',
        'X-Recaptcha-Token': token
    });
    
    // Include session token if available
    const sessionToken = SessionService.getSessionTokenSync();
    if (sessionToken) {
        headers['X-Session-Token'] = sessionToken;
    }
    
    const options = {
        method: method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin', // Include cookies for authentication
        headers: headers
    };
    
    // Only include body for non-GET/DELETE requests, or when data is provided for DELETE
    if (method !== 'GET' && (method !== 'DELETE' || data)) {
        options.body = JSON.stringify(data);
    }
    
    return options;
};

export const QuoteService = async (action, data, method = 'POST') => {
    console.log('QuoteService', data, method);
    const options = await getOptionsWithRecaptcha(data, action, method);   
    console.log('QuoteService-options', options);
    try {
        // Call BFF API instead of direct backend
        let url = `${baseUrl}/quotes/${action}`;
        console.log('QuoteService-url', url);
        const response = await fetch(url, options);
        
        // Store session token from response
        const newSessionToken = response.headers.get('X-Session-Token');
        if (newSessionToken) {
            SessionService.setSessionToken(newSessionToken);
        }
        
        if (!response.ok) {
            // Try to get the error response body
            let errorData = null;
            try {
                errorData = await response.json();
            } catch (jsonError) {
                console.warn('Could not parse error response as JSON:', jsonError);
            }
            
            // Create a more detailed error object
            const error = new Error(`HTTP error! status: ${response.status}`);
            error.status = response.status;
            error.data = errorData;
            throw error;
        }
        const jsonResponse = await response.json();
        console.log('QuoteService response:', jsonResponse);
        return jsonResponse;
    } catch (error) {
        console.error('QuoteService error:', error);
        throw error;
    }
}